import clone from 'clone';
import { useEffect, useState } from 'react';
import { Gizmo } from '../../gizmos';
import { IError, IGizmoFeatures } from '../../types';

interface IUseGizmoParams {
  gizmo: Gizmo;
}

/**
 * Custom hook that will be used by the Gizmo components
 *
 * @param {Gizmo} gizmo Gizmo's instance
 * @returns
 */
const useGizmo = ({ gizmo }: IUseGizmoParams) => {
  const [features, setFeatures] = useState<IGizmoFeatures>(gizmo.getFeatures());
  const [binder] = useState<any | undefined>(gizmo.getBinder());
  const [errors, setErrors] = useState<IError[]>([]);

  useEffect(() => {
    gizmo.features.subscribe((f: IGizmoFeatures) => {
      setFeatures(clone(f));
    });
    gizmo.errors.subscribe((e: IError[]) => {
      setErrors(e);
    });
  }, []);

  return {
    binder,
    config: gizmo.getConfig(),
    errors,
    features,
  };
};

export default useGizmo;
